import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41c20f03")

_pushScopeId("data-v-41c20f03")
const _hoisted_1 = {
  class: "grid",
  style: {"width":"700px"}
}
const _hoisted_2 = { class: "grid grid-cols-2 gap-x-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "mt-6 font-semibold" }, "Range saldo")
], -1)
const _hoisted_4 = { class: "grid grid-cols-2 mt-2 gap-x-4" }
const _hoisted_5 = { class: "grid grid-cols-2 mt-10 gap-x-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.show,
    title: _ctx.modalTitle,
    class: "send-invoice",
    "onUpdate:modelValue": _ctx.onCloseModal
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataWrapper, {
            label: "Tanggal",
            class: "w-full col-span-1"
          }, {
            default: _withId(() => [
              _createVNode(_component_TimeRangePicker, {
                class: "mt-2 w-full last-balance-calendar",
                onSelect: _ctx.setPeriode,
                startDate: _ctx.startDate,
                endDate: _ctx.endDate,
                isCloseDateAfterSelect: "",
                placeholder: "Pilih Tanggal",
                highlightOnSelected: true,
                customCalendar: true,
                customTotalMaxDate: 30,
                resetLimitOnSetOption: "",
                maxDate: new Date(),
                isSetMaxDate: "",
                ref: "rangePicker"
              }, null, 8, ["onSelect", "startDate", "endDate", "maxDate"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('Status Saldo'),
            class: "w-full col-span-1"
          }, {
            default: _withId(() => [
              _createVNode(_component_CustomDropdown, {
                selectedItem: _ctx.balanceStatus,
                "onUpdate:selectedItem": _cache[1] || (_cache[1] = ($event: any) => (_ctx.balanceStatus = $event)),
                options: _ctx.balanceOptions,
                onSelect: _ctx.onChangeBalance,
                placeholder: "Pilih status saldo",
                class: "mt-2 w-full",
                isCustomWidth: ""
              }, null, 8, ["selectedItem", "options", "onSelect"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_DataWrapper, {
            label: "Dari",
            class: "w-full col-span-1"
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.balanceRangeFrom,
                onChange: _cache[2] || (_cache[2] = (val) => _ctx.validateRangeSaldo(val, 'from')),
                prefix: "IDR",
                placeholder: "Masukkan jumlah",
                error: !!_ctx.errorBalanceRangeFrom,
                errorCaption: _ctx.errorBalanceRangeFrom
              }, null, 8, ["modelValue", "error", "errorCaption"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Sampai",
            class: "w-full col-span-1"
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.balanceRangeTo,
                onChange: _cache[3] || (_cache[3] = (val) => _ctx.validateRangeSaldo(val, 'to')),
                prefix: "IDR",
                placeholder: "Masukkan jumlah",
                error: !!_ctx.errorBalanceRangeTo,
                errorCaption: _ctx.errorBalanceRangeTo
              }, null, 8, ["modelValue", "error", "errorCaption"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_LpButton, {
          color: "white",
          textColor: "red-lp-2400",
          title: "Batalkan",
          isWidthFull: "",
          onClick: _ctx.onCloseModal,
          customClass: "border border-red-lp-2400"
        }, null, 8, ["onClick"]),
        _createVNode(_component_LpButton, {
          color: "red-lp-2400",
          textColor: "white",
          title: "Download",
          isWidthFull: "",
          onClick: _ctx.onSubmit,
          disabled: !_ctx.isValidDownload
        }, null, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onUpdate:modelValue"]))
})